import React, { Component } from "react";
import Jumbotron from "../../utils/Jumbotron";
import Layout from "../../header_footer/Layout";
import NoticiaDetalhes from "./NoticiaDetalhes";
import Evento from "./Evento";
import axios from 'axios';
import PropTypes from "prop-types";


class Noticia extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    
    this.state = {
      noticia: {}
    }
  }

  componentDidMount = () => {
    this.loadNoticia();
  }

  loadNoticia = async () => {

    let identifier = this.props.match.params.identifier;

    let res = {};
    try {
      res = await axios.get("/api/noticiasEventos/" + identifier, {
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf"
        }
      });
    } catch (error) {
      console.log(error);
    }

    if (res.data.noticiaEvento === null) {
      this.context.router.history.push("/not_found");
    }
    
    let noticia = res.data.noticiaEvento;
    this.setState({ noticia });

  }

  getType = () => {
      if(this.state.noticia.type === "EVENTO"){
        return "Evento";
      } else{
        return "Notícias e Projetos";
      }
    
    
  }

  render() {
    return (
      <Layout>
        <Jumbotron detalhe={this.getType()} title={this.state.noticia.title}></Jumbotron>
        <div className="container">
          <div id="detalhe-noticia" className="row justify-content-center">
            {this.state.noticia.type === "NOTICIA" ? 
              <NoticiaDetalhes noticia={this.state.noticia}></NoticiaDetalhes>
            :
              <Evento noticia={this.state.noticia}></Evento>
            }
          </div>
        </div>
      </Layout>
    );
  }
}

export default Noticia;
